// extracted by mini-css-extract-plugin
module.exports = {"smsBubble":"smsBubble--5da4b","smsSecondaryBubble":"smsSecondaryBubble--2ad8a","smsWebsiteLink":"smsWebsiteLink--bd841","smsMessagImg":"smsMessagImg--5d38c"};